import React from "react";
import { Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const JobDescription = () => {
    const jobDescription = useSelector((state:RootState) => state.campaign.jobDescription);

  return (
    <Grid
      item
      xs={12}
      id="description"
      sx={{ display: "flex", flexDirection: "column",margin: "0 16px"}}
    >
      <Typography
        sx={{ fontSize: "14px", fontWeight: 600, lineHeight: "normal" }}
      >
        Job Description
      </Typography>
      <div
      style={{
        fontSize:'14px',
        fontWeight:'400',
        lineHeight:"20px"
      
      }}
        dangerouslySetInnerHTML={{
          __html: jobDescription ? jobDescription : "",
        }}
      />
    </Grid>
  );
};

export default JobDescription;
